export default {
  appid: 'ec4f3a41582148198bd6a12bb911f53a',
  secret: '88372D38B448C394A34E9F6DED75DBE'
}
